import { LayoutList, CalendarDays } from "lucide-react";

import CustomTitle from "../../title/CustomTitle";
import CustomFilter from "../../filters/filter/CustomFilter";
import CustomFetching from "@/components/desktop/fetching/CustomFetching";
import CustomTable from "../CustomTable/CustomTable";
import CalendarView from "../../calendar/CalendarView";

import scaffoldStyles from "./ListScaffold.module.scss";

const ListScaffold = ({
	titleBreadcrumbs,
	subtitle,

	quickActions = [],

	showCreate,
	createLabel,
	onCreate,

	actionButtons = [],
	rightExtra = null,

	filterTitle,
	isFilterOpen,
	filters,
	appliedFilters,
	onFilterChange,
	onApplyFilters,
	onClearFilters,
	onClearOneFilter,
	onOpenFilter,
	onCloseFilter,

	isFetching,
	isLoading,
	data,
	totalItems,
	totalPages,
	toItem,
	fromItem,

	columns,
	pageIndex,
	onPageChange,
	pageSize,
	onPageSizeChange,
	sortBy,
	onSortByChange,
	pageSizeOptions = [20, 50, 100],
	initialPageSize,
	initialSortBy,
	onRowClick,

	customHeight = null,
	customStyle = null,
	compactHeaders = false,
	compactBody = false,
	useExpandableRows = false,
	renderExpandedContent,
	useRowspan = false,
	rowspanConfig,

	topContent,
	children,

	viewMode = "table",
	onViewModeChange,
	enableCalendarView = false,
	calendarDateAccessor = "application_order_date",
	calendarEventConfig,
	onCalendarEventClick,
	onCalendarMonthChange,
	renderCalendarEvent,
}) => {
	const isCalendarActive = enableCalendarView && viewMode === "calendar";

	const viewToggle =
		enableCalendarView && typeof onViewModeChange === "function" ? (
			<fieldset className={scaffoldStyles.viewToggle} aria-label="Cambiar vista">
				<button
					type="button"
					className={`${scaffoldStyles.viewToggleButton} ${viewMode === "table" ? scaffoldStyles.viewToggleButtonActive : ""}`}
					onClick={() => onViewModeChange("table")}
					aria-pressed={viewMode === "table"}
					title="Vista listado"
				>
					<LayoutList size={16} />
					<span>Lista</span>
				</button>
				<button
					type="button"
					className={`${scaffoldStyles.viewToggleButton} ${viewMode === "calendar" ? scaffoldStyles.viewToggleButtonActive : ""}`}
					onClick={() => onViewModeChange("calendar")}
					aria-pressed={viewMode === "calendar"}
					title="Vista calendario"
				>
					<CalendarDays size={16} />
					<span>Calendario</span>
				</button>
			</fieldset>
		) : null;

	const combinedRightExtra = viewToggle ? (
		<div className={scaffoldStyles.rightExtraGroup}>
			{rightExtra}
			{viewToggle}
		</div>
	) : (
		rightExtra
	);

	let bodyContent;
	if (isLoading) {
		bodyContent = <CustomFetching center size="lg" />;
	} else if (isCalendarActive) {
		bodyContent = (
			<CalendarView
				data={data}
				dateAccessor={calendarDateAccessor}
				eventConfig={calendarEventConfig}
				onEventClick={onCalendarEventClick}
				onMonthChange={onCalendarMonthChange}
				renderEvent={renderCalendarEvent}
			/>
		);
	} else {
		bodyContent = (
			<CustomTable
				columns={columns}
				data={data}
				totalItems={totalItems}
				totalPages={totalPages}
				toItem={toItem}
				fromItem={fromItem}
				pageIndex={pageIndex}
				onPageChange={onPageChange}
				pageSize={pageSize}
				onPageSizeChange={onPageSizeChange}
				sortBy={sortBy}
				onSortByChange={onSortByChange}
				pageSizeOptions={pageSizeOptions}
				initialPageSize={initialPageSize}
				initialSortBy={initialSortBy}
				onRowClick={onRowClick}
				hasFilters={filters && filters?.length > 0}
				customHeight={customHeight}
				customStyle={customStyle}
				compactHeaders={compactHeaders}
				compactBody={compactBody}
				useExpandableRows={useExpandableRows}
				renderExpandedContent={renderExpandedContent}
				useRowspan={useRowspan}
				rowspanConfig={rowspanConfig}
				actionButtons={actionButtons}
			/>
		);
	}

	return (
		<>
			{(titleBreadcrumbs || quickActions.length > 0) && (
				<CustomTitle
					title={titleBreadcrumbs}
					subtitle={subtitle}
					showCreate={showCreate}
					createLabel={createLabel}
					onCreate={onCreate}
					quickActions={quickActions}
					rightExtra={combinedRightExtra}
					isFetching={isFetching}
				/>
			)}{" "}
			{filters && filters?.length > 0 && (
				<CustomFilter
					open={isFilterOpen}
					title={filterTitle}
					filters={filters}
					appliedFilters={appliedFilters || filters}
					onChange={onFilterChange}
					onApply={onApplyFilters}
					onClear={onClearFilters}
					onClearOne={onClearOneFilter}
					onOpen={onOpenFilter}
					onClose={onCloseFilter}
					customStyle={customStyle}
				/>
			)}
			{topContent}
			{bodyContent}
			{children}
		</>
	);
};

export default ListScaffold;
